// eslint-disable-next-line import/order
import type { ComponentType } from 'react';
// eslint-disable-next-line import/order
import Loadable from 'react-loadable';
import type { CreateTeamDialogWrapperProps } from './main';

const LazyCreateTeamDialog: ComponentType<CreateTeamDialogWrapperProps> &
	Loadable.LoadableComponent = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_create-team-dialog" */ './main'
		),
	loading: () => null,
});
LazyCreateTeamDialog.displayName = 'lazy(CreateTeamDialog)';

export default LazyCreateTeamDialog;
